const SliceType = {
  SPONSORED_BRAND_PRODUCTS: 'sponsored_brand_products',
  BRAZE_BANNER: 'braze_banner',
};

export default SliceType;
